import React from "react";
import HeaderTop from "../components/Headertop";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import '../components/css/BlogStyle.css';


function TermsCondition(){
    return(
        <>
            <HeaderTop />
            <Navbar />
            <section className="page-banner">
                <div className="container">
                    <div className="banner-content">
                        <h1 className="fw-bold">Refund Policy</h1>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Refund Policy</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            <div class="container my-5">
                <div class="row g-4">
                    <div class="col-lg-12">
                        <h3>Refund-policy</h3>
                        <p>Refund of Fee or Replacement : (Applicable only for Classroom Study Courses) In case if a student is not able to continue the classes due to some unavoidable reasons, Vigyan Vriksh will provide two alternatives to such candidates: Student can avail the fees refund facility within first 3 days of the commencement of either batch or course. Fees will be refunded after deducting initial processing and admission charges of Rs. 5000/-. Refund amount will be paid through account payee cheque/NEFT only, which will be in the name of candidate. Refund requests made verbally, over telephones, e-mails or by fax will not be valid or accepted. Submit the refund and or replacement application in person to the coordinator in the admission office. Only the student or parents can submit “Fee Refund “application.</p>
                        <p>Please note that, we will not accept the Fee Refund applications from any other person/relative/friend. The policy of fee refund or seat replacement is strictly according to the above mentioned terms and is not negotiable under any circumstances. Any refund of fee or seat replacement received without proper documents like ID-card (if issued), fee receipt & written application after the expiry of applicable period will not be processed or entertained.</p>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
export default TermsCondition;